export let CheckoutType=/*#__PURE__*/function(CheckoutType){CheckoutType["GridCheckout"]="gridCheckout";return CheckoutType;}({});